/**
 * Platform access that isn't a subscription.
 *
 * - A member of a client org (BAM Consulting) is covered by the org's deal.
 *   Coleman signed off 2026-10-13, web and app: access sold to an
 *   organization for its staff, outside IAP (App Store 3.1.3(c)). Removing
 *   someone from the org ends it.
 * - BAM staff (is_admin) run the platform; Silva runs client orgs as an
 *   admin and was paywalled like a lapsed coach.
 *
 * Own rows only: org_members RLS lets a user read their memberships.
 */
import { supabase } from "../../supabaseClient";

export async function hasOrgOrStaffAccess(userId, profileRow) {
  if (!userId) return false;
  if (profileRow?.is_admin) return true;
  try {
    const { data, error } = await supabase
      .from("org_members").select("org_id").eq("user_id", userId).limit(1);
    return !error && (data || []).length > 0;
  } catch {
    return false;
  }
}
